module.exports = __webpack_public_path__ + "img/cbe.f473f26e.jpg";